module.exports = __webpack_public_path__ + "img/5.c188c91a.jpg";